import React, { RefObject } from "react"

import { Slot } from "@/components/Slot"
import { cn } from "@/utils/tailwind"

const variants = {
  default: "text-slate-700",
  secondary: "text-slate-500",
  link: "font-light text-slate-500 hover:text-slate-700",
}

const sizes = {
  xs: "text-xs",
  sm: "text-sm",
  md: "text-base",
  lg: "text-lg",
  xl: "text-xl",
}

interface Props extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: keyof typeof variants
  size?: keyof typeof sizes
  asChild?: boolean
  ref?: RefObject<HTMLSpanElement>
}

function Text({ className, variant = "default", size = "md", asChild = false, ref, children, ...props }: Props) {
  const Comp = asChild ? Slot : "span"
  return (
    <Comp className={cn(variants[variant], sizes[size], className)} ref={ref} {...props}>
      {children}
    </Comp>
  )
}

export { Text }
